import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import InputFile from '@app/components/input-file/InputFile';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import { NIL as NIL_UUID } from 'uuid';
import {
    messageError,
    messageToast,
    acceptImage,
    objectDataTypeCategory,
    styleSelectDefault,
    styleSelectError,
    status200
} from '../../utils/define';
import { BaseGatewayImage, ROLE_API } from '../../utils/apiUrl';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    name: yup.string().required(messageError.emptyMessage),
});

const RoleEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const roleId = paramUrl.get('id');

    const item = useQuery([roleId], () =>
        Get(ROLE_API.GET_ITEM, roleId)
    );

    // const listCate = useQuery(['getAllCate'], () =>
    //     Get(CATEGORY_API.GET_ALL_CATEGORY)
    // );

    const editFunc = useMutation((value) =>
        Put(ROLE_API.UPDATE_ITEM, value.id, value.data)
    );

    const handleEdit = async (values) => {
        const model = { ...values };
        // model.parentId = cateItem.data.parentId;
        // model.parentId = values.parentId === 'null' ? '' : values.parentId;

        const modelUpdate = {
            data: model,
            id: roleId
        };

        editFunc.mutate(modelUpdate, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    queryClient.setQueryData(roleId, modelUpdate);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    // const isLoading = cateItem.isLoading || listCate.isLoading;
    // const isError = cateItem.isError || listCate.isError;
    // const error = cateItem.isError ? cateItem.error : listCate.error;

    const isLoading = item.isLoading ? true : false;
    const isError = item.isError ? true : false;
    const error = item.isError ? item.error : null;

    // let menuData = [
    //     {
    //         name: 'Danh mục gốc',
    //         id: 'null',
    //         parentId: NIL_UUID
    //     }
    // ];
    // if (!listCate.isLoading && !listCate.isError) {
    //     menuData = menuData
    //         .concat(listCate.data.data.$values)
    //         .filter((x) => x.id !== cateId);
    // }

    return (
        <Card>
            <Card.Header as="h5">Sửa thông tin danh mục</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Loading...</div>
                ) : isError ? (
                    <div>An error has occurred: ${error.message}</div>
                ) : item.data == null ? (
                    <div>Danh mục không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            name:
                                item.data && item.data.name
                                    ? item.data.name
                                    : '',
                            parentId:
                                item.data.parentId === NIL_UUID
                                    ? 'null'
                                    : item.data.parentId,
                            roleCode:
                                item.data && item.data.roleCode
                                    ? item.data.roleCode
                                    : '',
                            description:
                                item.data && item.data.description
                                    ? item.data.description
                                    : '',
                            orderNumber:
                                item.data && item.data.orderNumber
                                    ? item.data.orderNumber
                                    : 0,
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <HorizontalFieldsRow
                                    fields={[
                                        {
                                            label: 'Tên quyền',
                                            name: 'name',
                                            value: values.name,
                                            onChange: handleChange,
                                            isInvalid: errors.name,
                                            error: errors.name
                                        },
                                        {
                                            label: 'Thứ tự',
                                            name: 'orderNumber',
                                            value: values.orderNumber,
                                            onChange: handleChange,
                                            isInvalid: errors.orderNumber,
                                            error: errors.orderNumber,
                                            type: "number"
                                        }
                                    ]}
                                />
                                <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Mã quyền *
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control
                                                placeholder="Mã quyền"
                                                type="text"
                                                name="roleCode"
                                                value={values.roleCode}
                                                onChange={handleChange}
                                                isInvalid={!!errors.roleCode}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.roleCode}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Mô tả
                                        </Form.Label>
                                        <Col sm="10">
                                            <Col sm="10">
                                                <Editor
                                                    name="description"
                                                    value={values.description}
                                                    onChange={(value) => {
                                                        setFieldValue(
                                                            'description',
                                                            value
                                                        );
                                                    }}
                                                />
                                            </Col>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() =>
                                                    history.goBack()
                                                }
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default RoleEdit;
